import * as types from './addPageActionTypes';
//step 1
export const setBroker = (id, name) => ({ type: types.SAVE_BROKER, id: id, name: name });
export const setTypeOfContract = (id, name) => ({ type: types.SAVE_TYPEOFCONTRACT, id: id, name: name });
export const setDateOfContract = (date) => ({ type: types.SAVE_DATEOFCONTRACT, date: date });
export const setSupplierType = (id, name) => ({ type: types.SAVE_SUPPLIERTYPE, id: id, name: name})
export const setSupplier = (id, name) => ({ type: types.SAVE_SUPPLIER, id: id, name: name });
export const setYear = (year) => ({ type: types.SAVE_YEAR, year: year });
export const setBuyingUnits = (id, name) => ({ type: types.SAVE_UNITS, id: id, name: name });
export const setTransportType = (id, name) => ({ type: types.SAVE_TRANSPORTTYPE, id: id, name: name });
export const setRemark = (remark) => ({ type: types.SAVE_REMARK, remark: remark });
export const setCertInfo = (info) => ({ type: types.SAVE_CERTINFO, info: info });
export const setVertstep = (step) => ({ type: types.SET_VERTSTEP, step: step});
export const setHorstep = (step) => ({ type: types.SET_HORSTEP, step: step});
export const setExternalRefCalculated = (externalReferenceCalculated) => ({ type: types.SET_EXTERNALREFCALCULATED, externalReferenceCalculated: externalReferenceCalculated});
export const setExternalRef = (externalReference) => ({ type: types.SET_EXTERNALREF, externalReference: externalReference});
export const setTransportPrice100Kg = (transp) => ({ type: types.SET_TRANSP , transp: transp});
export const setValidUntillDate = (date) => ({ type: types.SET_VALIDUNTILLDATE, date: date});
export const setDetailUOM = (id) => ({ type: types.SET_DETAILUOM , id: id});
export const setDataArea = (data) => ({type: types.SET_DATAAREA, data: data});
//step 2
export const SetProduct = (id) => ({ type: types.SET_PRODUCT , id: id});
export const SetFromDate= (date) => ({ type: types.SET_FROMDATE , fromDate: date});
export const SetToDate = (date) => ({ type: types.SET_TODATE , toDate: date});
export const SetQuantity = (qty) => ({ type: types.SET_QUANTITY , quantity: qty});
export const SetPrice = (price) => ({ type: types.SET_PRICE , price: price});
export const SetUnit = (unit) => ({ type: types.SET_UNIT , unit: unit});
export const AddProductData = (data) => ({ type: types.ADD_PRODUCTDATA , data: data});
export const RemoveProductData = (id) => ({ type: types.REMOVE_PRODUCTDATA , id: id});
export const SetNewId = (id) => ({ type: types.SET_NEWID , id: id});
export const SetContractPrice = (price) => ({ type: types.SET_CONTRACTPRICE , price: price});
export const SetOverdelivery = (value) => ({ type: types.SET_OVERDELIVERY , value: value});
export const SetEditMode = (value) => ({ type: types.SET_EDITMODE, value: value});
export const SetEditID = (id) => ({ type: types.SET_EDITID, id: id});
export const EditProductData = (data) => ({ type: types.EDIT_PRODUCTDATA , data: data});
export const SetDeleteID = (id) => ({ type: types.SET_DELETED, id: id});
export const SetPriceSchemeDialogVisible = (visible) => ({ type: types.SET_PRICESCHEMEDIALOGVISIBLE, visible: visible});

//Step 3
export const SetDialogState = (visible) => ({ type: types.SET_DIALOGSTATE, visible: visible});
export const AddFinishedContract = (data) => ({ type: types.ADD_CONTRACT, data: data});
export const ResetAddForm = () => ({ type: types.RESET_FORM});
export const SetExternalRefID = (id) => ({ type: types.SET_EXTERNALREFID, id: id});
export const setSelectedFreeClauses = (selectedFreeClauses) => ({ type: types.SAVE_SELECTEDFREECLAUSES, selectedFreeClauses: selectedFreeClauses });

//overview
export const SetEditContractMode = (data) => ({ type: types.SET_EDITCONTRACTMODE, data: data});
export const SetEditContractId = (id) => ({ type: types.SET_EDITCONTRACTID, id: id});
export const SetEditContractData = (data) => ({ type: types.SET_EDITCONTRACTDATA, data:data});
export const EditContract = (data) => ({ type: types.EDITCONTRACT, data: data});
export const setPurchaseOrderLines = (data) => ({ type: types.SET_PURCHASEORDERLINES, data: data});

//settings
export const EditReference = (editref) => ({ type: types.EDIT_REF, editref: editref});
